import getRetailTokenClient from "@utils/getRetailToken.client";
import { apiClient } from "./apiClient";
import { REQUEST_CALLBACK_URL } from "./endpoints";

export interface RequestCallbackPayload {
  callback_message: string;
}

export interface RequestCallbackApiResponse {
  status: string;
}

export interface RequestCallbackResponse {
  success: boolean;
  data?: RequestCallbackApiResponse;
  error?: {
    message: string;
  };
}

/**
 * Post request callback data to the callback API
 */
export const postRequestCallback = async (
  payload: RequestCallbackPayload
): Promise<RequestCallbackResponse> => {
  try {
    const retailToken = await getRetailTokenClient();
    
    if (!retailToken) {
      return {
        success: false,
        error: {
          message: "No retail token available",
        },
      };
    }

    // Make API request
    const response = await apiClient.post(
      REQUEST_CALLBACK_URL,
      payload,
      {
        headers: {
          "retailtoken": retailToken,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: response,
    };
  } catch (error: any) {
    console.error("Request callback API error:", error.message);
    return {
      success: false,
      error: {
        message: error instanceof Error ? error.message : "Unknown error",
      },
    };
  }
}; 